import React from "react";
import { ReferenceField, useRecordContext, useTranslate } from "react-admin";

import { ValueChipWithType } from "components/fields/ValueChipWithType";
import { ScannerLogContextType } from "entities/ScannerLogContextType";

const contextKeyByValue = Object.fromEntries(
	Object.entries(ScannerLogContextType).map(([key, value]) => [value, key])
);

const OrderContextChip = ({ typeLabel }) => {
	const order = useRecordContext();
	return (
		<ValueChipWithType
			value={order?.reference}
			link={order ? `#/orders/${order.id}/show` : null}
			typeLabel={typeLabel}
		/>
	);
};

export const ScannerLogContextField = ({ record }) => {
	const translate = useTranslate();
	if (!record) return null;

	const key = contextKeyByValue[record.context_type];
	const label = translate(`osfc.enums.scanner_log_context_type.${key}`);

	if (record.context_type === ScannerLogContextType.order && record.context_id) {
		return (
			<ReferenceField
				record={record}
				source="context_id"
				reference="orders"
				basePath="/orders"
				link={false}
			>
				<OrderContextChip typeLabel={label} />
			</ReferenceField>
		);
	}

	return <span>{label}</span>;
};
